module.exports = __webpack_public_path__ + "static/media/Country-Place-Emergency-Information.fc17042d.pdf";